import React, { useMemo, useState } from 'react';
import Select from '../../common/Select/Select';
import { useSelector } from 'react-redux';
import Button from '../../common/Button/Button';
import styles from './ShopifySelectRetailer.module.scss';

export function ShopifySelectRetailer(props) {
  const { user } = useSelector((state) => state.role);

  const options = useMemo(() => {
    if (!user?.retailers) return [];
    const options = user.retailers.map((retailer) => ({ label: retailer.name, value: retailer.id.toString() }));
    options.sort((optionA, optionB) => (optionB.label < optionA.label ? 1 : -1));
    return options;
  }, [user?.retailers]);

  const [selected, setSelected] = useState(options[0]?.value);

  const onContinue = () => {
    props.onContinue(selected);
  };

  if (!options.length) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <h3>Please select the retailer you want to connect your shop:</h3>
      <div className={styles.selectWrapper}>
        <Select options={options} onChange={setSelected} value={selected} />
      </div>
      <Button onClick={onContinue} text="Continue" />
    </div>
  );
}
